import { render, staticRenderFns } from "./ReportIndex.vue?vue&type=template&id=2d6d5de2"
import script from "./ReportIndex.vue?vue&type=script&lang=js"
export * from "./ReportIndex.vue?vue&type=script&lang=js"
import style0 from "./ReportIndex.vue?vue&type=style&index=0&id=2d6d5de2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports